"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogRequestBuilder = void 0;
const LoggingStateService_1 = require("./LoggingStateService");
class LogRequestBuilder {
    constructor() {
        this.logRequest = {};
    }
    messageTemplate(message) {
        this.logRequest.messageTemplate = message;
        return this;
    }
    appName(name) {
        this.logRequest.appName = name;
        return this;
    }
    appVersion(version) {
        this.logRequest.appVersion = version;
        return this;
    }
    featureArea(featureArea) {
        this.logRequest.featureArea = featureArea;
        return this;
    }
    fileName(fileName) {
        this.logRequest.fileName = fileName;
        return this;
    }
    lineNumber(lineNumber) {
        this.logRequest.lineNumber = lineNumber;
        return this;
    }
    logLevel(level) {
        switch (level) {
            case LoggingStateService_1.LogLevel.DEBUG:
                this.logRequest.logLevel = "DEBUG";
                break;
            case LoggingStateService_1.LogLevel.INFO:
                this.logRequest.logLevel = "INFO";
                break;
            case LoggingStateService_1.LogLevel.WARN:
                this.logRequest.logLevel = "WARN";
                break;
            case LoggingStateService_1.LogLevel.ERROR:
            default:
                this.logRequest.logLevel = "ERROR";
                break;
        }
        return this;
    }
    addContext(key, value) {
        if (!this.logRequest.context) {
            this.logRequest.context = {};
        }
        this.logRequest.context[key] = value;
        return this;
    }
    stack(stack) {
        this.logRequest.stack = stack;
        return this;
    }
    build() {
        return this.logRequest;
    }
}
exports.LogRequestBuilder = LogRequestBuilder;
//# sourceMappingURL=LogRequestBuilder.js.map